var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysOutlined = function SvgSysOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.6 14.969a1.6 1.6 0 0 1-1.6-1.6V2.6A1.6 1.6 0 0 1 4.6 1h4.585c.133 0 .26.053.355.147l3.288 3.29a.493.493 0 0 1 .147.355v8.58a1.6 1.6 0 0 1-1.6 1.599L4.6 14.969ZM4 2.598V13.37a.6.6 0 0 0 .6.6h6.78a.6.6 0 0 0 .6-.6v-8.37H9.009a.5.5 0 0 1-.5-.5v-2.5h-3.9a.599.599 0 0 0-.609.6v-.003Zm5.5 1.4h1.475L9.5 2.523v1.475Zm-.438 7.975a.5.5 0 0 1 0-.707l1.413-1.415-1.413-1.413a.5.5 0 0 1 .705-.708l1.768 1.768a.502.502 0 0 1 0 .708l-1.768 1.768a.501.501 0 0 1-.705.002v-.003Zm-2.646 0-1.77-1.768a.5.5 0 0 1 0-.708l1.77-1.768a.5.5 0 0 1 .705.708L5.708 9.85l1.413 1.415a.5.5 0 0 1-.705.711v-.003Z"
  })));
};
export default SvgSysOutlined;